<template>
    <div>
        <design-2021-apprentice-data-table
            class="las-imports"
            :items="tableData"
            :fields="importFields">
            <template v-slot:options>
                <b-button
                    class="btn-add btn-add-import"
                    type="button"
                    variant="primary"
                    label="Start nieuwe import"
                    @click="launchLasImport()">
                    {{ $t('school.start_new_import') }}
                </b-button>
            </template>

            <template v-slot:cell(mainGroups)="data">
                <span class="text-success">{{ data.item.mainGroups.successful }}</span>
                /
                <span class="text-danger">{{ 0 + data.item.mainGroups.failed }}</span>
            </template>

            <template v-slot:cell(groups)="data">
                <span class="text-success">{{ data.item.groups.successful }}</span>
                /
                <span class="text-danger">{{ 0 + data.item.groups.failed }}</span>
            </template>

            <template v-slot:cell(teachers)="data">
                <span class="text-success">{{ data.item.teachers.successful }}</span>
                /
                <span class="text-danger">{{ 0 + data.item.teachers.failed }}</span>
            </template>

            <template v-slot:cell(students)="data">
                <span class="text-success">{{ data.item.students.successful }}</span>
                /
                <span class="text-danger">{{ 0 + data.item.students.failed }}</span>
            </template>

            <template v-slot:cell(successful)="data">
                <div class="d-flex">
                    <div>
                        <i
                            class="fas fa-check-circle text-success mr-2"
                            v-if="data.item.successful"></i>
                        <i
                            class="fas fa-times-circle text-danger mr-2"
                            v-else></i>
                    </div>

                    <div>
                        <b-button
                            class="btn-eye btn-view-details btn-"
                            v-b-tooltip:hover
                            variant="primary-icon-only"
                            title="Details"
                            @click="openLasImportDetails(data.item.id)">
                        </b-button>
                    </div>
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </div>
</template>

<script>
export default {
    name: 'design-2021-school-las-import-component',
    props: ['lasLocationIn'],
    data() {
        return {
            importFields: [
                {
                    key: 'dateTime',
                    label: 'Op',
                },
                {
                    key: 'mainGroups',
                    label: this.$t('school.main_groups'),
                },
                {
                    key: 'groups',
                    label: this.$t('school.groups'),
                },
                {
                    key: 'teachers',
                    label: this.$t('school.teachers'),
                },
                {
                    key: 'students',
                    label: this.$t('school.students'),
                },
                {
                    key: 'provider',
                    label: this.$t('school.provider'),
                },
                {
                    key: 'successful',
                    label: this.$t('school.successful'),
                },
            ],
        };
    },
    computed: {
        tableData() {
            return this.lasLocationIn.las_import_logs
                .map((lasImportLog) => {
                    let date = new Date(lasImportLog.created_at);
                    let minutes = date.getMinutes();
                    if (minutes < 10) {
                        minutes = '0' + minutes;
                    }
                    let successful = false;
                    if (
                        lasImportLog.main_groups_successful === lasImportLog.main_groups_done &&
                        lasImportLog.groups_successful === lasImportLog.groups_done &&
                        lasImportLog.teachers_successful === lasImportLog.teachers_done &&
                        lasImportLog.students_successful === lasImportLog.students_done
                    ) {
                        successful = true;
                    }

                    return {
                        id: lasImportLog.id,
                        dateTime: date.toISOString().split('T')[0] + ' ' + date.getHours() + ':' + minutes,
                        createdAt: lasImportLog.created_at,
                        mainGroups: {
                            successful: lasImportLog.main_groups_successful,
                            failed: lasImportLog.main_groups_failed,
                        },
                        groups: {
                            successful: lasImportLog.groups_successful,
                            failed: lasImportLog.groups_failed,
                        },
                        teachers: {
                            successful: lasImportLog.teachers_successful,
                            failed: lasImportLog.teachers_failed,
                        },
                        students: {
                            successful: lasImportLog.students_successful,
                            failed: lasImportLog.students_failed,
                        },
                        provider: lasImportLog.provider,
                        successful: successful,
                    };
                })
                .sort(function (a, b) {
                    return new Date(b.createdAt) - new Date(a.createdAt);
                });
        },
    },
    methods: {
        launchLasImport() {
            this.alert
                .confirm(
                    this.$t('school.start_las_import'),
                    this.$t('school.you_are_going_to_start_a_new_las_import_are_you_sure'),
                    this.$t('school.start'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }

                    axios.get(this.routes.lasImportCurrentSchool()).then(() => {
                        this.alert
                            .notice(
                                this.$t('school.import_started'),
                                this.$t('school.import_is_started_it_can_take_a_moment_before_it_is_completed'),
                            )
                            .then(() => {
                                window.location.reload();
                            });
                    });
                });
        },
        openLasImportDetails(id) {
            window.location.href = this.routes.lasImportDetails(id);
        },
    },
};
</script>

<style scoped></style>
